import { render } from "./SendBulkSmsView.vue?vue&type=template&id=46bcdbed&scoped=true"
import script from "./SendBulkSmsView.vue?vue&type=script&lang=js"
export * from "./SendBulkSmsView.vue?vue&type=script&lang=js"

import "@/assets/css/report.css?vue&type=style&index=0&id=46bcdbed&scoped=true&lang=css"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46bcdbed"]])

export default __exports__